import axios from "axios";

const UpdateSurveyorProfile = async(formData) => {
try {
    const response = await axios.post('https://land-survey-project-2.onrender.com/updateSurveyor',formData);
    if(response && response.data){
        if(response.data.errors){
            const name = response.data.errors ?. surveyor_name;
             const email = response.data.errors ?. surveyor_email;
              const password = response.data.errors ?. surveyor_password;
               const phone = response.data.errors ?. surveyor_phone;
               const errorMsg = name ?. msg || email ?. msg || phone ?. msg || password ?. msg;
             return {
            error: true,
            message: errorMsg
        };
        }
        if(response.data.status === false){
        return {
            error: true,
            message: response.data.message
        };
        }
        return {
            data: response.data.updated,
            newToken: response.data.newToken
        };
    }
} catch (err) {
console.log(err);
return {
    error: true,
    message: 'Not you it me'
};
}
}
export default UpdateSurveyorProfile;